<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M9.16666 14.1663L10.8333 15.833C10.9975 15.9972 11.1924 16.1274 11.4068 16.2162C11.6213 16.305 11.8512 16.3508 12.0833 16.3508C12.3155 16.3508 12.5453 16.305 12.7598 16.2162C12.9743 16.1274 13.1692 15.9972 13.3333 15.833C13.4975 15.6689 13.6277 15.474 13.7165 15.2595C13.8054 15.045 13.8511 14.8152 13.8511 14.583C13.8511 14.3509 13.8054 14.121 13.7165 13.9065C13.6277 13.692 13.4975 13.4972 13.3333 13.333"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.6669 11.6671L13.7502 13.7504C14.0817 14.0819 14.5313 14.2682 15.0002 14.2682C15.469 14.2682 15.9187 14.0819 16.2502 13.7504C16.5817 13.4189 16.768 12.9693 16.768 12.5004C16.768 12.0316 16.5817 11.5819 16.2502 11.2504L13.0169 8.01709C12.5481 7.54892 11.9127 7.28595 11.2502 7.28595C10.5877 7.28595 9.95227 7.54892 9.48352 8.01709L8.75019 8.75042C8.41867 9.08194 7.96903 9.26819 7.50019 9.26819C7.03135 9.26819 6.58171 9.08194 6.25019 8.75042C5.91867 8.4189 5.73242 7.96926 5.73242 7.50042C5.73242 7.03158 5.91867 6.58194 6.25019 6.25042L8.59186 3.90875C9.35206 3.15054 10.3434 2.66755 11.4091 2.53623C12.4747 2.40491 13.5537 2.63278 14.4752 3.18375L14.8669 3.41709C15.2217 3.63124 15.6436 3.70552 16.0502 3.62542L17.5002 3.33375"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.5 2.5L18.3333 11.6667H16.6667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.49999 2.5L1.66666 11.6667L7.08332 17.0833C7.41484 17.4149 7.86448 17.6011 8.33332 17.6011C8.80216 17.6011 9.2518 17.4149 9.58332 17.0833C9.91484 16.7518 10.1011 16.3022 10.1011 15.8333C10.1011 15.3645 9.91484 14.9149 9.58332 14.5833"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.5 3.33301H9.16667"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconHandshake',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
